import { makeStyles } from 'tss-react/mui'

import { hubloTheme } from '@front/theme'

export const useSeparatorStyles = makeStyles()(() => ({
  border: {
    borderBottom: `1px solid ${hubloTheme.palette.tektiteLight.main}`,
  },
  borderWithGutters: {
    '&::after': {
      content: '""',
      display: 'block',
      borderBottom: `1px solid ${hubloTheme.palette.tektiteLight.main}`,
    },
  },
  none: { padding: hubloTheme.spacing(0, 0) }, // height: 1px
  xxs: { padding: hubloTheme.spacing(0.25, 0) }, // height: 4px
  xs: { padding: hubloTheme.spacing(0.5, 0) }, // height: 8px
  s: { padding: hubloTheme.spacing(1, 0) }, //  height: 16px
  m: { padding: hubloTheme.spacing(1.5, 0) }, //  height: 24px
  l: { padding: hubloTheme.spacing(2, 0) }, // height: 32px
  xl: { padding: hubloTheme.spacing(3, 0) }, //  height: 48px
  horizontalMarginXs: { margin: hubloTheme.spacing(0, 0.5) },
  horizontalMarginS: { margin: hubloTheme.spacing(0, 1) },
  horizontalMarginM: { margin: hubloTheme.spacing(0, 1.5) },
  horizontalMarginL: { margin: hubloTheme.spacing(0, 2) },
  horizontalMarginXl: { margin: hubloTheme.spacing(0, 3) },
  padding: {
    padding: 25,
  },
  hasWhiteBackground: {
    backgroundColor: 'white',
  },
}))
